import { cartState } from './cart.reducer';
import { cartPersist } from './epics/cartPersist.epic';
import { cartHydrate } from './epics/cartHydrate.epic';
import { cartRefresh } from './epics/cartRefresh.epic';
import { cartFetch } from './epics/cartFetch.epic';
import { cartAddConfig } from './epics/cartAddConfig.epic';
import { cartItemDeleteEpic } from './epics/cartItemDelete.epic';
import { clearMessages } from './epics/clearMessages.epic';
import { userSignedOutReaction } from './epics/userSignedOutReaction.epic';
import { userSignedInReaction } from './epics/userSignedInReaction.epic';
import { cartAddSimple } from './epics/cartAddSimple.epic';
import { cartAdd } from './epics/cartAdd.epic';
import { cartItemUpdateEpic } from './epics/cartItemUpdate.epic';
import { cartReset } from './epics/cartReset.epic';

export const NAME = 'cart';

const epics = {
    /**
     * Refresh/save of state
     */
    cartHydrate,
    cartPersist,
    cartRefresh,
    cartReset,
    cartFetch,

    /**
     * Actions that affect the cart
     */
    cartAdd,
    cartAddConfig,
    cartAddSimple,
    cartItemDeleteEpic,
    cartItemUpdateEpic,

    /**
     * State based cleanups
     */
    clearMessages,
    userSignedOutReaction,
    userSignedInReaction,
};

export function cartRegister(overrides?: Partial<typeof epics>) {
    const mergedEpics = {
        ...epics,
        ...overrides,
    };
    return {
        epics: Object.keys(mergedEpics).map((key) => mergedEpics[key]),
        reducers: { [NAME]: cartState },
        name: NAME,
    };
}
